import Splide from "@splidejs/splide";

export function initServicesSlider(splideEl) {
    splideEl = splideEl || document.querySelector('#home-services-slider.splide');
    if (!splideEl) return null;

    // Guard: skip if track/list aren't in the DOM yet
    if (!splideEl.querySelector('.splide__track') || !splideEl.querySelector('.splide__list')) {
        return null;
    }

    // Fix cross-realm element issue in Elementor editor:
    // Elements created in the editor context fail instanceof checks in the iframe.
    // Re-import into the current document context so Splide's internal checks pass.
    if (!(splideEl instanceof HTMLElement)) {
        const adopted = document.importNode(splideEl, true);
        splideEl.parentNode.replaceChild(adopted, splideEl);
        splideEl = adopted;
    }

    // Destroy previous instance if exists (for editor re-renders)
    if (splideEl._splideInstance) {
        splideEl._splideInstance.destroy();
    }

    let splide;

    try {
        splide = new Splide(splideEl, {
            type: 'loop',
            perPage: 4,
            pagination: false,
            easing: 'ease-in-out',
            lazyLoad: false,
            arrows: false,
            padding: { left: 24 },
            mediaQuery: 'max',
            breakpoints: {
                1023: { padding: { left: 24, right: 48 }, perPage: 2 },
                639: { padding: 24, perPage: 1 },
            }
        }).mount();
    } catch (e) {
        return null;
    }

    splideEl._splideInstance = splide;

    function showImg(imgEl) {
        if (imgEl instanceof HTMLImageElement) {
            imgEl.classList.add('media-loaded');
            setTimeout(() => {
                imgEl.classList.remove('media-to-show', 'media-loaded');
                splide.refresh();
            }, 400);
        }
    }

    splideEl.querySelectorAll('img.media-to-show').forEach(imgEl => {
        if (imgEl.complete) {
            showImg(imgEl);
        } else {
            imgEl.addEventListener('load', () => {
                showImg(imgEl);
            });
        }
    });

    return splide;
}

jQuery(window).on('elementor/frontend/init', function () {
    if (!elementorFrontend.isEditMode()) return;

    elementorFrontend.hooks.addAction(
        'frontend/element_ready/mcc_home_services.default',
        function ($scope) {
            const splideEl = $scope.find('#home-services-slider.splide')[0];
            if (!splideEl) return;

            const tryInit = (attempts) => {
                if (attempts > 10) return;
                const result = initServicesSlider(splideEl);
                if (!result) {
                    setTimeout(() => tryInit(attempts + 1), 300);
                }
            };
            tryInit(0);
        }
    );
});